import { Box } from '@mui/material';
import 'react-animated-slider/build/horizontal.css';
import { useRecoilValue } from 'recoil';
import { bannerOpenState } from '../atoms/banner';
import { carouselAll } from '../atoms/carousel';
import { ImageUtils } from '../framework/utils';
import BannerSelector from './BannerSelector';

function AsideStack() {
  const carousels = useRecoilValue(carouselAll)
  const isOpen = useRecoilValue<boolean>(bannerOpenState)

  return (
    <>
      <Box sx={{
          '@media only screen and (max-width: 980px)': {
              display: 'none',
              visibility: 'hidden',
              width: '0px!important'
          },
          '@media only screen and (min-width: 980px)': {
              display: 'flex',
              flexDirection: 'column',
              mt: 0.5,
              gap: 1.5, 
              //flexGrow: 0,
              //flexShrink: 4,
              maxHeight: 'calc(100vh - 62px)',
              overflow: 'auto',
              width: '384px',
              minWidth: '384px',
              paddingRight: '4px',
              overflowX: 'hidden',
              transform: 'translate(0, -12px)'
          }                        
        }}>
        {isOpen && 
          <BannerSelector />
        }
        {carousels.map((item, index) => 
          <div key={index}>
          {item.imageOnly ?
            <Box>
              <a href={item.link} target="_blank" rel="noreferrer" style={{textDecoration: 'none'}}>
                <img src={item.imageType === 'F' ? ImageUtils.fromBase64ToDataUrl(item.fileEncoded ? item.fileEncoded : '', 'png') : item.imageUrl} 
                  style={{width: '100%', borderRadius: '8px', border: '1px solid #e0e0e0'}} alt={item.title}>
              </img>
              </a>
            </Box>
          :
          <div>
            <a href={item.link} target="_blank" rel="noreferrer" style={{textDecoration: 'none'}}>
            <Box key={index} sx={{display: 'flex', borderRadius: '8px', border: '1px solid #e0e0e0', flexDirection: 'column', gap: 4, 
                flexShrink: 4, textAlign: 'center', alignItems: 'center', marginBottom: '6px', width: '100%',
                background: `url('${item.imageType === 'F' ? ImageUtils.fromBase64ToDataUrl(item.fileEncoded ? item.fileEncoded : '', 'png') : item.imageUrl}') no-repeat center center`, 
                backgroundSize: 'cover'
                }}>
              <Box sx={{display: 'flex', alignItems: 'center', maxHeight: '40px', color: (theme) => item.color ? item.color : theme.palette.primary.main}}>
                <h1>{item.title}</h1>
              </Box>
              <Box sx={{display: 'flex', flexDirection: 'column', px: 1, alignItems: 'center', maxHeight: '140px', justifyContent: 'center' }}>
                <Box sx={{display: 'flex', flexDirection: 'column', color: (theme) => item.color ? item.color : theme.palette.primary.main}}>
                  <div dangerouslySetInnerHTML={{ __html: item.payload }} />
                </Box>
              </Box>
              {/*
              <Box sx={{display: 'flex', flexDirection: 'column', flexShrink: 4, textAlign: 'center'}}>
                <Button className={classes.button} sx={{maxHeight: '40px', color: (theme) => item.color ? item.color : theme.palette.primary.main}} 
                      href={item.link} variant="outlined" target="_blank" >
                      {t(item.buttonText)}
                </Button>
              </Box>
              */}
            </Box>
            </a>
          </div>
          }
          </div>
        )}
      </Box>
    </>
  )

}

export default AsideStack;